import Vue from "vue";
import Vuetify from "vuetify/lib";

import es from "vuetify/lib/locale/es";
import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { es },
    current: "es"
  },
  theme: {
    themes: {
      light: {
        primary: colors.blue.base,
        secondary: colors.blue.accent2,
        accent: colors.pink.base
      }
    }
  },
  icons: {
    iconfont: "md"
  }
});
